import { useContext, useEffect, useState } from "react";
import cardStyles from "../styles/Card.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { createFault, fetchFault, updateFault } from "../api";
import { AlertModalContext } from "./AlertModal";

import buttonStyles from "../styles/Button.module.css";
import adminStyles from "../styles/AdminView.module.css";
import { GlobalContext } from "../App";
import { useAuth } from "react-oidc-context";

export default function AddOrEditFaultView() {
    const { site, id } = useParams<{site:string, id:string}>();
    const [faultText, setFaultText] = useState<string>();
    const [newFaultText, setNewFaultText] = useState<string>();

    // alert modal state
    const { setShowAlertModal, setAlertMessage } = useContext(AlertModalContext);

    const navigate = useNavigate();

    const {globalSite, setSite} = useContext(GlobalContext);
    const auth = useAuth();

    useEffect(() => {
        if (globalSite === undefined || globalSite === "") {
            if (typeof auth.user?.profile.site === "string") {
                setSite(auth.user?.profile.site)
            } else if (typeof site === "string") {
                setSite(site)
            }
        }
    }, [globalSite, site, auth.user?.profile.site, setSite])

    useEffect(() => {
        if (id) {
            fetchFault(parseInt(id)).then((f) => {
                setFaultText(f.description)
            })
        }
    })

    // modal open/close
    const openAlertModal = (text:string) => {
        setAlertMessage(text);
        setShowAlertModal(true);
    }

    function displayId() {
        if (id) {
            return (
                <div>
                    ID: #{id}
                </div>
            )
        }
    }

    function displayOriginalDescription() {
        if (id) {
            return (
                <div>
                    Original Fault Description: {faultText}
                </div>
            )
        }
    }

    function save() {
        if (newFaultText === undefined) {
            openAlertModal("Please set description for fault");
            return
        }
        if (id) {
            updateFault(parseInt(id), newFaultText)
            navigate(-1)
        } else {
            createFault(newFaultText)
            navigate(-1)
        }
    }

    return (
        <div className={cardStyles.card}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%"
            }}
            >
            <h2
                style={{
                    width: "100%",
                }}
            >Add Fault</h2>
            {displayId()}
            {displayOriginalDescription()}
            <input
                id="faultText"
                type="text"
                value={newFaultText}
                onChange={(e) => setNewFaultText(e.target.value)}
                placeholder="New Fault Description"
                style={{
                    width: "100%",
                    padding: "8px 8px",
                    fontSize: "1rem",
                    borderRadius: 4,
                    border: "1px solid #ccc",
                }}
            />
            <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                marginTop: "8px"
            }}>
                <button
                    className={`${buttonStyles.button} ${buttonStyles.primary}`}
                    onClick={save}
                >Save</button>
                <button
                    className={`${buttonStyles.button} ${buttonStyles.close}`}
                    onClick={() => navigate(-1)}
                >Cancel</button>
            </div>
        </div>
    )
}
